/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { FCMRegistrationToken } from '../model';
// @ts-ignore
import { FCMRegistrationTokenCreateRequest } from '../model';
// @ts-ignore
import { LogoutRequest } from '../model';
// @ts-ignore
import { OneTimeLogin } from '../model';
// @ts-ignore
import { PatchedOneTimeLoginRequest } from '../model';
// @ts-ignore
import { PatchedResetPasswordRequest } from '../model';
// @ts-ignore
import { PatchedSellerResetPasswordConfirmRequest } from '../model';
// @ts-ignore
import { PatchedUserUpdatePasswordRequest } from '../model';
// @ts-ignore
import { ProfileTokenObtainPairResponseRequest } from '../model';
// @ts-ignore
import { ResetPasswordContactRequest } from '../model';
// @ts-ignore
import { SellerResetPasswordRequest } from '../model';
// @ts-ignore
import { TokenObtainPairResponse } from '../model';
// @ts-ignore
import { TokenRefreshRequest } from '../model';
// @ts-ignore
import { TokenRefreshResponse } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * UserAuthenticationApi - axios parameter creator
 * @export
 */
export const UserAuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Captures a user\'s FCM registrationToken
         * @summary Captures a user\'s FCM registrationToken
         * @param {FCMRegistrationTokenCreateRequest} fCMRegistrationTokenCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerFcmCreateTokenCreate: async (fCMRegistrationTokenCreateRequest: FCMRegistrationTokenCreateRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fCMRegistrationTokenCreateRequest' is not null or undefined
            assertParamExists('sellerFcmCreateTokenCreate', 'fCMRegistrationTokenCreateRequest', fCMRegistrationTokenCreateRequest)
            const localVarPath = `/v2/seller/fcm/create-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fCMRegistrationTokenCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates the users email and password and logs the user in.   Returning their JWT token, refresh token and their current profile.
         * @summary Authenticates the user
         * @param {ProfileTokenObtainPairResponseRequest} profileTokenObtainPairResponseRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerLoginCreate: async (profileTokenObtainPairResponseRequest: ProfileTokenObtainPairResponseRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileTokenObtainPairResponseRequest' is not null or undefined
            assertParamExists('sellerLoginCreate', 'profileTokenObtainPairResponseRequest', profileTokenObtainPairResponseRequest)
            const localVarPath = `/v2/seller/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileTokenObtainPairResponseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Logs the user out by blacklisting their current refresh
         * @summary Logs the user out
         * @param {LogoutRequest} logoutRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerLogoutCreate: async (logoutRequest: LogoutRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'logoutRequest' is not null or undefined
            assertParamExists('sellerLogoutCreate', 'logoutRequest', logoutRequest)
            const localVarPath = `/v2/seller/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logoutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends out an SMS to the user with a 6 digit reset password token
         * @summary Requests to reset the sellers password
         * @param {SellerResetPasswordRequest} sellerResetPasswordRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerResetPasswordCreate: async (sellerResetPasswordRequest: SellerResetPasswordRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sellerResetPasswordRequest' is not null or undefined
            assertParamExists('sellerResetPasswordCreate', 'sellerResetPasswordRequest', sellerResetPasswordRequest)
            const localVarPath = `/v2/seller/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sellerResetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The code is the code sent out in the SMS  Validation on the code may return a 400 VALIDATION_ERROR if the code has expired after 2 hours from being sent, it is not found, the code and mobile dont match up, or it has already been used before
         * @summary Resets the users password
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedSellerResetPasswordConfirmRequest} [patchedSellerResetPasswordConfirmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerResetPasswordPartialUpdate: async (aaSource?: string, patchedSellerResetPasswordConfirmRequest?: PatchedSellerResetPasswordConfirmRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/seller/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedSellerResetPasswordConfirmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts a refresh token and returns a new access token and refresh token for the user to use
         * @summary Refreshes a users access token
         * @param {TokenRefreshRequest} tokenRefreshRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerTokenRefreshCreate: async (tokenRefreshRequest: TokenRefreshRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenRefreshRequest' is not null or undefined
            assertParamExists('sellerTokenRefreshCreate', 'tokenRefreshRequest', tokenRefreshRequest)
            const localVarPath = `/v2/seller/token/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenRefreshRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the users password
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedUserUpdatePasswordRequest} [patchedUserUpdatePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerUpdatePasswordPartialUpdate: async (aaSource?: string, patchedUserUpdatePasswordRequest?: PatchedUserUpdatePasswordRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/seller/update-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUserUpdatePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates the users email and password and logs the user in.   Returning their JWT token, refresh token and their current profile.
         * @summary Authenticates the user
         * @param {ProfileTokenObtainPairResponseRequest} profileTokenObtainPairResponseRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthLoginCreate: async (profileTokenObtainPairResponseRequest: ProfileTokenObtainPairResponseRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileTokenObtainPairResponseRequest' is not null or undefined
            assertParamExists('userAuthLoginCreate', 'profileTokenObtainPairResponseRequest', profileTokenObtainPairResponseRequest)
            const localVarPath = `/v2/user/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileTokenObtainPairResponseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Logs the user out by blacklisting their current refresh
         * @summary Logs the user out
         * @param {LogoutRequest} logoutRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthLogoutCreate: async (logoutRequest: LogoutRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'logoutRequest' is not null or undefined
            assertParamExists('userAuthLogoutCreate', 'logoutRequest', logoutRequest)
            const localVarPath = `/v2/user/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logoutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates a one-time login token
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthOneTimeCreate: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/user/auth/one-time`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns valid User access and refresh tokens along with their profile information
         * @summary Validates a one-time login token
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedOneTimeLoginRequest} [patchedOneTimeLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthOneTimePartialUpdate: async (aaSource?: string, patchedOneTimeLoginRequest?: PatchedOneTimeLoginRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/user/auth/one-time`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedOneTimeLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the users password
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedUserUpdatePasswordRequest} [patchedUserUpdatePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthPasswordPartialUpdate: async (aaSource?: string, patchedUserUpdatePasswordRequest?: PatchedUserUpdatePasswordRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/user/auth/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUserUpdatePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends out an email or SMS to the user with a reset password token
         * @summary Requests to reset the users password
         * @param {ResetPasswordContactRequest} resetPasswordContactRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthPasswordResetCreate: async (resetPasswordContactRequest: ResetPasswordContactRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordContactRequest' is not null or undefined
            assertParamExists('userAuthPasswordResetCreate', 'resetPasswordContactRequest', resetPasswordContactRequest)
            const localVarPath = `/v2/user/auth/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordContactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The code is the code sent out with a link via email/sms
         * @summary Resets the users password
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedResetPasswordRequest} [patchedResetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthPasswordResetPartialUpdate: async (aaSource?: string, patchedResetPasswordRequest?: PatchedResetPasswordRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/user/auth/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedResetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts a refresh token and returns a new access token and refresh token for the user to use
         * @summary Refreshes a users access token
         * @param {TokenRefreshRequest} tokenRefreshRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthTokenRefreshCreate: async (tokenRefreshRequest: TokenRefreshRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenRefreshRequest' is not null or undefined
            assertParamExists('userAuthTokenRefreshCreate', 'tokenRefreshRequest', tokenRefreshRequest)
            const localVarPath = `/v2/user/auth/token/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenRefreshRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAuthenticationApi - functional programming interface
 * @export
 */
export const UserAuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserAuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * Captures a user\'s FCM registrationToken
         * @summary Captures a user\'s FCM registrationToken
         * @param {FCMRegistrationTokenCreateRequest} fCMRegistrationTokenCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerFcmCreateTokenCreate(fCMRegistrationTokenCreateRequest: FCMRegistrationTokenCreateRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FCMRegistrationToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerFcmCreateTokenCreate(fCMRegistrationTokenCreateRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validates the users email and password and logs the user in.   Returning their JWT token, refresh token and their current profile.
         * @summary Authenticates the user
         * @param {ProfileTokenObtainPairResponseRequest} profileTokenObtainPairResponseRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerLoginCreate(profileTokenObtainPairResponseRequest: ProfileTokenObtainPairResponseRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenObtainPairResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerLoginCreate(profileTokenObtainPairResponseRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Logs the user out by blacklisting their current refresh
         * @summary Logs the user out
         * @param {LogoutRequest} logoutRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerLogoutCreate(logoutRequest: LogoutRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerLogoutCreate(logoutRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sends out an SMS to the user with a 6 digit reset password token
         * @summary Requests to reset the sellers password
         * @param {SellerResetPasswordRequest} sellerResetPasswordRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerResetPasswordCreate(sellerResetPasswordRequest: SellerResetPasswordRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerResetPasswordCreate(sellerResetPasswordRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The code is the code sent out in the SMS  Validation on the code may return a 400 VALIDATION_ERROR if the code has expired after 2 hours from being sent, it is not found, the code and mobile dont match up, or it has already been used before
         * @summary Resets the users password
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedSellerResetPasswordConfirmRequest} [patchedSellerResetPasswordConfirmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerResetPasswordPartialUpdate(aaSource?: string, patchedSellerResetPasswordConfirmRequest?: PatchedSellerResetPasswordConfirmRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerResetPasswordPartialUpdate(aaSource, patchedSellerResetPasswordConfirmRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Accepts a refresh token and returns a new access token and refresh token for the user to use
         * @summary Refreshes a users access token
         * @param {TokenRefreshRequest} tokenRefreshRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerTokenRefreshCreate(tokenRefreshRequest: TokenRefreshRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenRefreshResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerTokenRefreshCreate(tokenRefreshRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the users password
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedUserUpdatePasswordRequest} [patchedUserUpdatePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerUpdatePasswordPartialUpdate(aaSource?: string, patchedUserUpdatePasswordRequest?: PatchedUserUpdatePasswordRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerUpdatePasswordPartialUpdate(aaSource, patchedUserUpdatePasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validates the users email and password and logs the user in.   Returning their JWT token, refresh token and their current profile.
         * @summary Authenticates the user
         * @param {ProfileTokenObtainPairResponseRequest} profileTokenObtainPairResponseRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAuthLoginCreate(profileTokenObtainPairResponseRequest: ProfileTokenObtainPairResponseRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenObtainPairResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAuthLoginCreate(profileTokenObtainPairResponseRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Logs the user out by blacklisting their current refresh
         * @summary Logs the user out
         * @param {LogoutRequest} logoutRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAuthLogoutCreate(logoutRequest: LogoutRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAuthLogoutCreate(logoutRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generates a one-time login token
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAuthOneTimeCreate(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OneTimeLogin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAuthOneTimeCreate(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns valid User access and refresh tokens along with their profile information
         * @summary Validates a one-time login token
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedOneTimeLoginRequest} [patchedOneTimeLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAuthOneTimePartialUpdate(aaSource?: string, patchedOneTimeLoginRequest?: PatchedOneTimeLoginRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenObtainPairResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAuthOneTimePartialUpdate(aaSource, patchedOneTimeLoginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the users password
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedUserUpdatePasswordRequest} [patchedUserUpdatePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAuthPasswordPartialUpdate(aaSource?: string, patchedUserUpdatePasswordRequest?: PatchedUserUpdatePasswordRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAuthPasswordPartialUpdate(aaSource, patchedUserUpdatePasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sends out an email or SMS to the user with a reset password token
         * @summary Requests to reset the users password
         * @param {ResetPasswordContactRequest} resetPasswordContactRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAuthPasswordResetCreate(resetPasswordContactRequest: ResetPasswordContactRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAuthPasswordResetCreate(resetPasswordContactRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The code is the code sent out with a link via email/sms
         * @summary Resets the users password
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedResetPasswordRequest} [patchedResetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAuthPasswordResetPartialUpdate(aaSource?: string, patchedResetPasswordRequest?: PatchedResetPasswordRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAuthPasswordResetPartialUpdate(aaSource, patchedResetPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Accepts a refresh token and returns a new access token and refresh token for the user to use
         * @summary Refreshes a users access token
         * @param {TokenRefreshRequest} tokenRefreshRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAuthTokenRefreshCreate(tokenRefreshRequest: TokenRefreshRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenRefreshResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAuthTokenRefreshCreate(tokenRefreshRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserAuthenticationApi - factory interface
 * @export
 */
export const UserAuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserAuthenticationApiFp(configuration)
    return {
        /**
         * Captures a user\'s FCM registrationToken
         * @summary Captures a user\'s FCM registrationToken
         * @param {FCMRegistrationTokenCreateRequest} fCMRegistrationTokenCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerFcmCreateTokenCreate(fCMRegistrationTokenCreateRequest: FCMRegistrationTokenCreateRequest, aaSource?: string, options?: any): AxiosPromise<FCMRegistrationToken> {
            return localVarFp.sellerFcmCreateTokenCreate(fCMRegistrationTokenCreateRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates the users email and password and logs the user in.   Returning their JWT token, refresh token and their current profile.
         * @summary Authenticates the user
         * @param {ProfileTokenObtainPairResponseRequest} profileTokenObtainPairResponseRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerLoginCreate(profileTokenObtainPairResponseRequest: ProfileTokenObtainPairResponseRequest, aaSource?: string, options?: any): AxiosPromise<TokenObtainPairResponse> {
            return localVarFp.sellerLoginCreate(profileTokenObtainPairResponseRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Logs the user out by blacklisting their current refresh
         * @summary Logs the user out
         * @param {LogoutRequest} logoutRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerLogoutCreate(logoutRequest: LogoutRequest, aaSource?: string, options?: any): AxiosPromise<string> {
            return localVarFp.sellerLogoutCreate(logoutRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends out an SMS to the user with a 6 digit reset password token
         * @summary Requests to reset the sellers password
         * @param {SellerResetPasswordRequest} sellerResetPasswordRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerResetPasswordCreate(sellerResetPasswordRequest: SellerResetPasswordRequest, aaSource?: string, options?: any): AxiosPromise<void> {
            return localVarFp.sellerResetPasswordCreate(sellerResetPasswordRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * The code is the code sent out in the SMS  Validation on the code may return a 400 VALIDATION_ERROR if the code has expired after 2 hours from being sent, it is not found, the code and mobile dont match up, or it has already been used before
         * @summary Resets the users password
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedSellerResetPasswordConfirmRequest} [patchedSellerResetPasswordConfirmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerResetPasswordPartialUpdate(aaSource?: string, patchedSellerResetPasswordConfirmRequest?: PatchedSellerResetPasswordConfirmRequest, options?: any): AxiosPromise<void> {
            return localVarFp.sellerResetPasswordPartialUpdate(aaSource, patchedSellerResetPasswordConfirmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts a refresh token and returns a new access token and refresh token for the user to use
         * @summary Refreshes a users access token
         * @param {TokenRefreshRequest} tokenRefreshRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerTokenRefreshCreate(tokenRefreshRequest: TokenRefreshRequest, aaSource?: string, options?: any): AxiosPromise<TokenRefreshResponse> {
            return localVarFp.sellerTokenRefreshCreate(tokenRefreshRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the users password
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedUserUpdatePasswordRequest} [patchedUserUpdatePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerUpdatePasswordPartialUpdate(aaSource?: string, patchedUserUpdatePasswordRequest?: PatchedUserUpdatePasswordRequest, options?: any): AxiosPromise<void> {
            return localVarFp.sellerUpdatePasswordPartialUpdate(aaSource, patchedUserUpdatePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates the users email and password and logs the user in.   Returning their JWT token, refresh token and their current profile.
         * @summary Authenticates the user
         * @param {ProfileTokenObtainPairResponseRequest} profileTokenObtainPairResponseRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthLoginCreate(profileTokenObtainPairResponseRequest: ProfileTokenObtainPairResponseRequest, aaSource?: string, options?: any): AxiosPromise<TokenObtainPairResponse> {
            return localVarFp.userAuthLoginCreate(profileTokenObtainPairResponseRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Logs the user out by blacklisting their current refresh
         * @summary Logs the user out
         * @param {LogoutRequest} logoutRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthLogoutCreate(logoutRequest: LogoutRequest, aaSource?: string, options?: any): AxiosPromise<string> {
            return localVarFp.userAuthLogoutCreate(logoutRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates a one-time login token
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthOneTimeCreate(aaSource?: string, options?: any): AxiosPromise<OneTimeLogin> {
            return localVarFp.userAuthOneTimeCreate(aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns valid User access and refresh tokens along with their profile information
         * @summary Validates a one-time login token
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedOneTimeLoginRequest} [patchedOneTimeLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthOneTimePartialUpdate(aaSource?: string, patchedOneTimeLoginRequest?: PatchedOneTimeLoginRequest, options?: any): AxiosPromise<TokenObtainPairResponse> {
            return localVarFp.userAuthOneTimePartialUpdate(aaSource, patchedOneTimeLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the users password
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedUserUpdatePasswordRequest} [patchedUserUpdatePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthPasswordPartialUpdate(aaSource?: string, patchedUserUpdatePasswordRequest?: PatchedUserUpdatePasswordRequest, options?: any): AxiosPromise<void> {
            return localVarFp.userAuthPasswordPartialUpdate(aaSource, patchedUserUpdatePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends out an email or SMS to the user with a reset password token
         * @summary Requests to reset the users password
         * @param {ResetPasswordContactRequest} resetPasswordContactRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthPasswordResetCreate(resetPasswordContactRequest: ResetPasswordContactRequest, aaSource?: string, options?: any): AxiosPromise<void> {
            return localVarFp.userAuthPasswordResetCreate(resetPasswordContactRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * The code is the code sent out with a link via email/sms
         * @summary Resets the users password
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedResetPasswordRequest} [patchedResetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthPasswordResetPartialUpdate(aaSource?: string, patchedResetPasswordRequest?: PatchedResetPasswordRequest, options?: any): AxiosPromise<void> {
            return localVarFp.userAuthPasswordResetPartialUpdate(aaSource, patchedResetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts a refresh token and returns a new access token and refresh token for the user to use
         * @summary Refreshes a users access token
         * @param {TokenRefreshRequest} tokenRefreshRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthTokenRefreshCreate(tokenRefreshRequest: TokenRefreshRequest, aaSource?: string, options?: any): AxiosPromise<TokenRefreshResponse> {
            return localVarFp.userAuthTokenRefreshCreate(tokenRefreshRequest, aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sellerFcmCreateTokenCreate operation in UserAuthenticationApi.
 * @export
 * @interface UserAuthenticationApiSellerFcmCreateTokenCreateRequest
 */
export interface UserAuthenticationApiSellerFcmCreateTokenCreateRequest {
    /**
     * 
     * @type {FCMRegistrationTokenCreateRequest}
     * @memberof UserAuthenticationApiSellerFcmCreateTokenCreate
     */
    readonly fCMRegistrationTokenCreateRequest: FCMRegistrationTokenCreateRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserAuthenticationApiSellerFcmCreateTokenCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerLoginCreate operation in UserAuthenticationApi.
 * @export
 * @interface UserAuthenticationApiSellerLoginCreateRequest
 */
export interface UserAuthenticationApiSellerLoginCreateRequest {
    /**
     * 
     * @type {ProfileTokenObtainPairResponseRequest}
     * @memberof UserAuthenticationApiSellerLoginCreate
     */
    readonly profileTokenObtainPairResponseRequest: ProfileTokenObtainPairResponseRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserAuthenticationApiSellerLoginCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerLogoutCreate operation in UserAuthenticationApi.
 * @export
 * @interface UserAuthenticationApiSellerLogoutCreateRequest
 */
export interface UserAuthenticationApiSellerLogoutCreateRequest {
    /**
     * 
     * @type {LogoutRequest}
     * @memberof UserAuthenticationApiSellerLogoutCreate
     */
    readonly logoutRequest: LogoutRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserAuthenticationApiSellerLogoutCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerResetPasswordCreate operation in UserAuthenticationApi.
 * @export
 * @interface UserAuthenticationApiSellerResetPasswordCreateRequest
 */
export interface UserAuthenticationApiSellerResetPasswordCreateRequest {
    /**
     * 
     * @type {SellerResetPasswordRequest}
     * @memberof UserAuthenticationApiSellerResetPasswordCreate
     */
    readonly sellerResetPasswordRequest: SellerResetPasswordRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserAuthenticationApiSellerResetPasswordCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerResetPasswordPartialUpdate operation in UserAuthenticationApi.
 * @export
 * @interface UserAuthenticationApiSellerResetPasswordPartialUpdateRequest
 */
export interface UserAuthenticationApiSellerResetPasswordPartialUpdateRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserAuthenticationApiSellerResetPasswordPartialUpdate
     */
    readonly aaSource?: string

    /**
     * 
     * @type {PatchedSellerResetPasswordConfirmRequest}
     * @memberof UserAuthenticationApiSellerResetPasswordPartialUpdate
     */
    readonly patchedSellerResetPasswordConfirmRequest?: PatchedSellerResetPasswordConfirmRequest
}

/**
 * Request parameters for sellerTokenRefreshCreate operation in UserAuthenticationApi.
 * @export
 * @interface UserAuthenticationApiSellerTokenRefreshCreateRequest
 */
export interface UserAuthenticationApiSellerTokenRefreshCreateRequest {
    /**
     * 
     * @type {TokenRefreshRequest}
     * @memberof UserAuthenticationApiSellerTokenRefreshCreate
     */
    readonly tokenRefreshRequest: TokenRefreshRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserAuthenticationApiSellerTokenRefreshCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerUpdatePasswordPartialUpdate operation in UserAuthenticationApi.
 * @export
 * @interface UserAuthenticationApiSellerUpdatePasswordPartialUpdateRequest
 */
export interface UserAuthenticationApiSellerUpdatePasswordPartialUpdateRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserAuthenticationApiSellerUpdatePasswordPartialUpdate
     */
    readonly aaSource?: string

    /**
     * 
     * @type {PatchedUserUpdatePasswordRequest}
     * @memberof UserAuthenticationApiSellerUpdatePasswordPartialUpdate
     */
    readonly patchedUserUpdatePasswordRequest?: PatchedUserUpdatePasswordRequest
}

/**
 * Request parameters for userAuthLoginCreate operation in UserAuthenticationApi.
 * @export
 * @interface UserAuthenticationApiUserAuthLoginCreateRequest
 */
export interface UserAuthenticationApiUserAuthLoginCreateRequest {
    /**
     * 
     * @type {ProfileTokenObtainPairResponseRequest}
     * @memberof UserAuthenticationApiUserAuthLoginCreate
     */
    readonly profileTokenObtainPairResponseRequest: ProfileTokenObtainPairResponseRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserAuthenticationApiUserAuthLoginCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for userAuthLogoutCreate operation in UserAuthenticationApi.
 * @export
 * @interface UserAuthenticationApiUserAuthLogoutCreateRequest
 */
export interface UserAuthenticationApiUserAuthLogoutCreateRequest {
    /**
     * 
     * @type {LogoutRequest}
     * @memberof UserAuthenticationApiUserAuthLogoutCreate
     */
    readonly logoutRequest: LogoutRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserAuthenticationApiUserAuthLogoutCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for userAuthOneTimeCreate operation in UserAuthenticationApi.
 * @export
 * @interface UserAuthenticationApiUserAuthOneTimeCreateRequest
 */
export interface UserAuthenticationApiUserAuthOneTimeCreateRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserAuthenticationApiUserAuthOneTimeCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for userAuthOneTimePartialUpdate operation in UserAuthenticationApi.
 * @export
 * @interface UserAuthenticationApiUserAuthOneTimePartialUpdateRequest
 */
export interface UserAuthenticationApiUserAuthOneTimePartialUpdateRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserAuthenticationApiUserAuthOneTimePartialUpdate
     */
    readonly aaSource?: string

    /**
     * 
     * @type {PatchedOneTimeLoginRequest}
     * @memberof UserAuthenticationApiUserAuthOneTimePartialUpdate
     */
    readonly patchedOneTimeLoginRequest?: PatchedOneTimeLoginRequest
}

/**
 * Request parameters for userAuthPasswordPartialUpdate operation in UserAuthenticationApi.
 * @export
 * @interface UserAuthenticationApiUserAuthPasswordPartialUpdateRequest
 */
export interface UserAuthenticationApiUserAuthPasswordPartialUpdateRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserAuthenticationApiUserAuthPasswordPartialUpdate
     */
    readonly aaSource?: string

    /**
     * 
     * @type {PatchedUserUpdatePasswordRequest}
     * @memberof UserAuthenticationApiUserAuthPasswordPartialUpdate
     */
    readonly patchedUserUpdatePasswordRequest?: PatchedUserUpdatePasswordRequest
}

/**
 * Request parameters for userAuthPasswordResetCreate operation in UserAuthenticationApi.
 * @export
 * @interface UserAuthenticationApiUserAuthPasswordResetCreateRequest
 */
export interface UserAuthenticationApiUserAuthPasswordResetCreateRequest {
    /**
     * 
     * @type {ResetPasswordContactRequest}
     * @memberof UserAuthenticationApiUserAuthPasswordResetCreate
     */
    readonly resetPasswordContactRequest: ResetPasswordContactRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserAuthenticationApiUserAuthPasswordResetCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for userAuthPasswordResetPartialUpdate operation in UserAuthenticationApi.
 * @export
 * @interface UserAuthenticationApiUserAuthPasswordResetPartialUpdateRequest
 */
export interface UserAuthenticationApiUserAuthPasswordResetPartialUpdateRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserAuthenticationApiUserAuthPasswordResetPartialUpdate
     */
    readonly aaSource?: string

    /**
     * 
     * @type {PatchedResetPasswordRequest}
     * @memberof UserAuthenticationApiUserAuthPasswordResetPartialUpdate
     */
    readonly patchedResetPasswordRequest?: PatchedResetPasswordRequest
}

/**
 * Request parameters for userAuthTokenRefreshCreate operation in UserAuthenticationApi.
 * @export
 * @interface UserAuthenticationApiUserAuthTokenRefreshCreateRequest
 */
export interface UserAuthenticationApiUserAuthTokenRefreshCreateRequest {
    /**
     * 
     * @type {TokenRefreshRequest}
     * @memberof UserAuthenticationApiUserAuthTokenRefreshCreate
     */
    readonly tokenRefreshRequest: TokenRefreshRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserAuthenticationApiUserAuthTokenRefreshCreate
     */
    readonly aaSource?: string
}

/**
 * UserAuthenticationApi - object-oriented interface
 * @export
 * @class UserAuthenticationApi
 * @extends {BaseAPI}
 */
export class UserAuthenticationApi extends BaseAPI {
    /**
     * Captures a user\'s FCM registrationToken
     * @summary Captures a user\'s FCM registrationToken
     * @param {UserAuthenticationApiSellerFcmCreateTokenCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthenticationApi
     */
    public sellerFcmCreateTokenCreate(requestParameters: UserAuthenticationApiSellerFcmCreateTokenCreateRequest, options?: any) {
        return UserAuthenticationApiFp(this.configuration).sellerFcmCreateTokenCreate(requestParameters.fCMRegistrationTokenCreateRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates the users email and password and logs the user in.   Returning their JWT token, refresh token and their current profile.
     * @summary Authenticates the user
     * @param {UserAuthenticationApiSellerLoginCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthenticationApi
     */
    public sellerLoginCreate(requestParameters: UserAuthenticationApiSellerLoginCreateRequest, options?: any) {
        return UserAuthenticationApiFp(this.configuration).sellerLoginCreate(requestParameters.profileTokenObtainPairResponseRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Logs the user out by blacklisting their current refresh
     * @summary Logs the user out
     * @param {UserAuthenticationApiSellerLogoutCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthenticationApi
     */
    public sellerLogoutCreate(requestParameters: UserAuthenticationApiSellerLogoutCreateRequest, options?: any) {
        return UserAuthenticationApiFp(this.configuration).sellerLogoutCreate(requestParameters.logoutRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends out an SMS to the user with a 6 digit reset password token
     * @summary Requests to reset the sellers password
     * @param {UserAuthenticationApiSellerResetPasswordCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthenticationApi
     */
    public sellerResetPasswordCreate(requestParameters: UserAuthenticationApiSellerResetPasswordCreateRequest, options?: any) {
        return UserAuthenticationApiFp(this.configuration).sellerResetPasswordCreate(requestParameters.sellerResetPasswordRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The code is the code sent out in the SMS  Validation on the code may return a 400 VALIDATION_ERROR if the code has expired after 2 hours from being sent, it is not found, the code and mobile dont match up, or it has already been used before
     * @summary Resets the users password
     * @param {UserAuthenticationApiSellerResetPasswordPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthenticationApi
     */
    public sellerResetPasswordPartialUpdate(requestParameters: UserAuthenticationApiSellerResetPasswordPartialUpdateRequest = {}, options?: any) {
        return UserAuthenticationApiFp(this.configuration).sellerResetPasswordPartialUpdate(requestParameters.aaSource, requestParameters.patchedSellerResetPasswordConfirmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accepts a refresh token and returns a new access token and refresh token for the user to use
     * @summary Refreshes a users access token
     * @param {UserAuthenticationApiSellerTokenRefreshCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthenticationApi
     */
    public sellerTokenRefreshCreate(requestParameters: UserAuthenticationApiSellerTokenRefreshCreateRequest, options?: any) {
        return UserAuthenticationApiFp(this.configuration).sellerTokenRefreshCreate(requestParameters.tokenRefreshRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the users password
     * @param {UserAuthenticationApiSellerUpdatePasswordPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthenticationApi
     */
    public sellerUpdatePasswordPartialUpdate(requestParameters: UserAuthenticationApiSellerUpdatePasswordPartialUpdateRequest = {}, options?: any) {
        return UserAuthenticationApiFp(this.configuration).sellerUpdatePasswordPartialUpdate(requestParameters.aaSource, requestParameters.patchedUserUpdatePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates the users email and password and logs the user in.   Returning their JWT token, refresh token and their current profile.
     * @summary Authenticates the user
     * @param {UserAuthenticationApiUserAuthLoginCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthenticationApi
     */
    public userAuthLoginCreate(requestParameters: UserAuthenticationApiUserAuthLoginCreateRequest, options?: any) {
        return UserAuthenticationApiFp(this.configuration).userAuthLoginCreate(requestParameters.profileTokenObtainPairResponseRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Logs the user out by blacklisting their current refresh
     * @summary Logs the user out
     * @param {UserAuthenticationApiUserAuthLogoutCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthenticationApi
     */
    public userAuthLogoutCreate(requestParameters: UserAuthenticationApiUserAuthLogoutCreateRequest, options?: any) {
        return UserAuthenticationApiFp(this.configuration).userAuthLogoutCreate(requestParameters.logoutRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates a one-time login token
     * @param {UserAuthenticationApiUserAuthOneTimeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthenticationApi
     */
    public userAuthOneTimeCreate(requestParameters: UserAuthenticationApiUserAuthOneTimeCreateRequest = {}, options?: any) {
        return UserAuthenticationApiFp(this.configuration).userAuthOneTimeCreate(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns valid User access and refresh tokens along with their profile information
     * @summary Validates a one-time login token
     * @param {UserAuthenticationApiUserAuthOneTimePartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthenticationApi
     */
    public userAuthOneTimePartialUpdate(requestParameters: UserAuthenticationApiUserAuthOneTimePartialUpdateRequest = {}, options?: any) {
        return UserAuthenticationApiFp(this.configuration).userAuthOneTimePartialUpdate(requestParameters.aaSource, requestParameters.patchedOneTimeLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the users password
     * @param {UserAuthenticationApiUserAuthPasswordPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthenticationApi
     */
    public userAuthPasswordPartialUpdate(requestParameters: UserAuthenticationApiUserAuthPasswordPartialUpdateRequest = {}, options?: any) {
        return UserAuthenticationApiFp(this.configuration).userAuthPasswordPartialUpdate(requestParameters.aaSource, requestParameters.patchedUserUpdatePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends out an email or SMS to the user with a reset password token
     * @summary Requests to reset the users password
     * @param {UserAuthenticationApiUserAuthPasswordResetCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthenticationApi
     */
    public userAuthPasswordResetCreate(requestParameters: UserAuthenticationApiUserAuthPasswordResetCreateRequest, options?: any) {
        return UserAuthenticationApiFp(this.configuration).userAuthPasswordResetCreate(requestParameters.resetPasswordContactRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The code is the code sent out with a link via email/sms
     * @summary Resets the users password
     * @param {UserAuthenticationApiUserAuthPasswordResetPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthenticationApi
     */
    public userAuthPasswordResetPartialUpdate(requestParameters: UserAuthenticationApiUserAuthPasswordResetPartialUpdateRequest = {}, options?: any) {
        return UserAuthenticationApiFp(this.configuration).userAuthPasswordResetPartialUpdate(requestParameters.aaSource, requestParameters.patchedResetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accepts a refresh token and returns a new access token and refresh token for the user to use
     * @summary Refreshes a users access token
     * @param {UserAuthenticationApiUserAuthTokenRefreshCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthenticationApi
     */
    public userAuthTokenRefreshCreate(requestParameters: UserAuthenticationApiUserAuthTokenRefreshCreateRequest, options?: any) {
        return UserAuthenticationApiFp(this.configuration).userAuthTokenRefreshCreate(requestParameters.tokenRefreshRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
